export enum AnalyticsEvents {
  AGENT_CAPABILITY_CHOSEN = 'agentCapabilityChosen',
  AGENT_CAPABILITY_CONFIG_FAILURE = 'agentCapabilityConfigFailure',
  AGENT_CAPABILITY_CONFIG_SUCCESS = 'agentCapabilityConfigSuccess',
  AGENT_CAPABILITY_MODIFIED = 'agentCapabilityModified',
  AGENT_CREATION_ABANDONED = 'agentCreationAbandoned',
  AGENT_CREATION_COMPLETED = 'agentCreationCompleted',
  AGENT_CREATION_STARTED = 'agentCreationStarted',
  AGENT_DELETION_ATTEMPTED = 'agentDeletionAttempted',
  AGENT_DELETION_FAILURE = 'agentDeletionFailure',
  AGENT_DELETION_SUCCESS = 'agentDeletionSuccess',
  AGENT_DEPARTMENT_SELECTED = 'agentDepartmentSelected',
  AGENT_EDIT_ABANDONED = 'agentEditAbandoned',
  AGENT_EDIT_COMPLETED = 'agentEditCompleted',
  AGENT_EDIT_FAILED = 'agentEditFailed',
  AGENT_EDIT_STARTED = 'agentEditStarted',
  AGENT_EDIT_STEP_DURATION = 'agentEditStepDuration',
  AGENT_EDIT_STEP_NAVIGATION = 'agentEditStepNavigation',
  AGENT_LINE_ASSIGNMENT_FAILURE = 'agentLineAssignmentFailure',
  AGENT_LINE_ASSIGNMENT_SUCCESS = 'agentLineAssignmentSuccess',
  AGENT_LINE_CHOSEN = 'agentLineChosen',
  AGENT_LINE_COUNTRY_CODE_SELECTED = 'agentLineCountryCodeSelected',
  AGENT_LINE_SWITCHED = 'agentLineSwitched',
  AGENT_STATUS_CHANGED = 'agentStatusChanged',
  AGENT_TEST_BUTTON_CLICKED = 'agentTestButtonClicked',
  AGENT_TEST_CALL_ATTEMPTED = 'agentTestCallAttempted',
  AGENT_TEST_CALL_FAILURE = 'agentTestCallFailure',
  AGENT_TEST_CALL_SUCCESS = 'agentTestCallSuccess',
  AGENT_TEST_MODAL_CLOSED = 'agentTestModalClosed',
  AGENT_TEST_MODAL_OPENED = 'agentTestModalOpened',
  AGENT_TRANSFER_CALLS_CONFIGURED = 'agentTransferCallsConfigured',
  AGENT_SELECTION_CHANGED = 'agentSelectionChanged',
  BILLING_MANAGEMENT_BUTTON_CLICKED = 'billingManagementButtonClicked',
  CHOOSE_PLAN_BUTTON_CLICKED = 'choosePlanButtonClicked',
  COMPANY_DETAILS_COMPLETION_ABANDONED = 'companyDetailsCompletionAbandoned',
  COMPANY_DETAILS_COMPLETION_FIELD_UPDATED = 'companyDetailsCompletionFieldUpdated',
  COMPANY_DETAILS_COMPLETION_STARTED = 'companyDetailsCompletionStarted',
  DASHBOARD_TABS_CALL_AGENTS_CLICKED = 'dashboardTabsCallAgentsClicked',
  DASHBOARD_TABS_CHAT_AGENTS_CLICKED = 'dashboardTabsChatAgentsClicked',
  DATE_RANGE_CHANGED = 'dateRangeChanged',
  HELP_PAGE_CONSULTATION_BUTTON_CLICKED = 'helpPageConsultationButtonClicked',
  HOME_PAGE_DEMO_BUTTON_CLICKED = 'homePageDemoButtonClicked',
  HOME_PAGE_SIGN_IN_BUTTON_CLICKED = 'homePageSignInButtonClicked',
  HOME_PAGE_START_HERE_BUTTON_CLICKED = 'homePageStartHereButtonClicked',
  KNOWLEDGE_CREATION_ABANDONED = 'knowledgeCreationAbandoned',
  KNOWLEDGE_CREATION_COMPLETED = 'knowledgeCreationCompleted',
  KNOWLEDGE_CREATION_STARTED = 'knowledgeCreationStarted',
  KNOWLEDGE_DELETION_ATTEMPTED = 'knowledgeDeletionAttempted',
  KNOWLEDGE_DELETION_FAILURE = 'knowledgeDeletionFailure',
  KNOWLEDGE_DELETION_SUCCESS = 'knowledgeDeletionSuccess',
  KNOWLEDGE_EDIT_ABANDONED = 'knowledgeEditAbandoned',
  KNOWLEDGE_EDIT_COMPLETED = 'knowledgeEditCompleted',
  KNOWLEDGE_EDIT_DURATION = 'knowledgeEditDuration',
  KNOWLEDGE_EDIT_FAILED = 'knowledgeEditFailed',
  KNOWLEDGE_EDIT_STARTED = 'knowledgeEditStarted',
  KNOWLEDGE_FORM_FIELD_UPDATED = 'knowledgeFormFieldUpdated',
  KNOWLEDGE_FORM_VALIDATION_ERROR = 'knowledgeFormValidationError',
  PAGE_VIEWED = 'pageViewed',
  SETTINGS_UPDATE = 'settingsUpdate',
  SIGN_IN = 'signIn',
  SIGN_IN_ABANDONED = 'signInAbandoned',
  SIGN_IN_STARTED = 'signInStarted',
  SIGN_UP = 'signUp',
  SIGN_UP_ABANDONED = 'signUpAbandoned',
  SIGN_UP_STARTED = 'signUpStarted',
  SUBSCRIPTION_PURCHASE_ABANDONED = 'subscriptionPurchaseAbandoned',
  SUBSCRIPTION_PURCHASE_STARTED = 'subscriptionPurchaseStarted',
  SUBSCRIPTION_PURCHASE_VIEWED = 'subscriptionPurchaseViewed',
  UPGRADE_AFTER_FIRST_AGENT_CREATED = 'upgradeAfterFirstAgentCreated',
  UPGRADE_BUTTON_CLICKED = 'upgradeButtonClicked',
}
